import { Checkbox, FormControlLabel, FormGroup, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { InvoiceServices } from '../../../utils/invoice-utils'
import CustomTextField from '../../common/CustomTextField'

interface InvoiceServiceSelectProps {
    onChange: (value: string) => void
    oldSelectedServices?: string[]
}

const serviceOptions = [
    { value: '1', label: InvoiceServices.OnsiteEvent },
    { value: '2', label: InvoiceServices.RentAttractionWithService },
    { value: '3', label: InvoiceServices.RentAttraction },
    { value: '4', label: InvoiceServices.Other },
]

const InvoiceServiceSelect: React.FC<InvoiceServiceSelectProps> = ({
    onChange,
    oldSelectedServices,
}: InvoiceServiceSelectProps) => {
    const theme = useTheme()

    const [selectedServices, setSelectedServices] = useState<boolean[]>(
        oldSelectedServices
            ? [
                  oldSelectedServices[0] ? true : false,
                  oldSelectedServices[1] ? true : false,
                  oldSelectedServices[2] ? true : false,
                  oldSelectedServices[3] ? true : false,
              ]
            : [false, false, false, false]
    )

    const [otherServiceText, setOtherServiceText] = useState<string>(selectedServices[3] ? oldSelectedServices?.[3] ?? '' : '')

    const handleServiceChange = (index: number) => {
        const newSelectedServices = [...selectedServices]
        newSelectedServices[index] = !newSelectedServices[index]
        setSelectedServices(newSelectedServices)
        onChange(
            serviceOptions
                .filter((_, i) => newSelectedServices[i])
                .map((s) => (s.value === '4' ? otherServiceText : s.label))
                .join(', ')
        )
    }

    return (
        <FormGroup>
            {serviceOptions.map((option, index) => (
                <FormControlLabel
                    key={option.value}
                    control={
                        <Checkbox
                            checked={selectedServices[index]}
                            onChange={() => handleServiceChange(index)}
                            name={option.value}
                        />
                    }
                    label={option.label}
                />
            ))}
            <CustomTextField
                disabled={!selectedServices[3]}
                size='small'
                label='Ostatní'
                value={otherServiceText}
                onChange={(e) => setOtherServiceText(e.target.value)}
                onBlur={() =>
                    onChange(
                        serviceOptions
                            .filter((_, i) => selectedServices[i])
                            .map((s) => (s.value === '4' ? otherServiceText : s.label))
                            .join(', ')
                    )
                }
                style={{ marginBottom: theme.spacing(2) }}
            />
        </FormGroup>
    )
}

export default InvoiceServiceSelect
